import React from 'react';

const TrainingHighlights = () => (
  <section className="training-section choose-us">
    <h2>Why Attend This Training?</h2>
    <p>
      Discover how we evaluate investment properties in real time using the exact strategies our top
      students rely on to find, flip, and build long-term wealth.
    </p>
  </section>
);

export default TrainingHighlights;
